
    import { defineComponent } from 'vue';
    import { useRouter } from 'vue-router';
    import {
      IonCard,
      IonCardHeader,
      IonCardSubtitle,
      IonCardTitle,
      IonCardContent,
      IonIcon,
    } from '@ionic/vue';
    import { chevronForwardOutline } from 'ionicons/icons';
  export default defineComponent({
      name: 'HomeDiovoid',
      components: {
        IonCard,
        IonCardHeader,
        IonCardSubtitle,
        IonCardTitle,
        IonCardContent,
        IonIcon,
      },
      setup() {
      const router = useRouter();
      const goToSite = () => {
        window.location.href = 'https://www.etsy.com/shop/Diovoid';
      };
      return {
        router,
        chevronForwardOutline,
        goToSite,
      };
    },
  });
